import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { HomeIcon } from 'foundations-assets/icons/components/HomeIcon';
import { ChecklistIcon } from 'foundations-assets/icons/components/ChecklistIcon';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { LineItemsIcon } from 'foundations-assets/icons/components/LineItemsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_MAP = {
  billing: CreditCardIcon,
  'billing.subscriptions': CreditCardIcon,
  'billing.invoices': LineItemsIcon,
  tickets: TasksIcon,
  deals: DealsIcon,
  onboarding: ChecklistIcon,
  reference: DocumentsIcon,
  'reference.component-examples': DocumentsIcon,
  'reference.token-explorer': DocumentsIcon,
  'reference.projects': DocumentsIcon,
  'reference.forms': DocumentsIcon
};
export function PortalsSideNavIcon({
  name
}) {
  const Icon = name && ICON_MAP[name] ? ICON_MAP[name] : HomeIcon;
  return /*#__PURE__*/_jsx(Icon, {
    color: "text-core-default",
    size: '500'
  });
}